module.exports = __webpack_public_path__ + "static/media/isa1.95ea92e9.png";